export const CURRENCY_EXPRESSION = new RegExp(/(\d)(?=(\d{3})+(?!\d))/g);
export const PERCENT_EXPRESSION = new RegExp(/(?!^)(?=(?:\d{3})+(?:\.|$))/g);
export const NUMBER_EXPRESSION = new RegExp(/(?!^)(?=(?:\d{3})+(?:\.|$))/g);
export const DEFAULT_REPLACE = '';
export const DEFAULT_INVALID = '';
export const BYTE_UNITS = [' Bytes', ' KB', ' MB', ' GB', ' TB'];
export const BYTE_UNIT = [' Byte', ' KB', ' MB', ' GB', ' TB'];
